import './App.css';
import { Routes, Route } from "react-router-dom";
import Home from './Pages/Home';
import Header from './Components/header/Header';
import Footer from './Components/footer/Footer';
import ScrollToTop from './Components/ScrollToTop';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import TermsAndConditions from './Pages/TermsAndConditions';
import About from './Pages/About';
import Donation from './Pages/Donation';
import DonationDetail from './Pages/DonationDetail';
import PaymentNow from './Pages/PaymentNow';
import Project from './Pages/Project';
import Foundation from './Pages/Foundation';
import Gallery from './Pages/Gallery';
import Impact from './Pages/Impact';
import ContactUs from './Pages/ContactUs';
import CreateNewCampaign from './Pages/CreateNewCampaign';
import Campaign from './Pages/Campaign';
import Members from './Pages/Members';
import Profile from './Pages/Profile';
import Feeds from './Pages/Feeds';
import SignUp from './Pages/SignUp';
import SignIn from './Pages/SignIn';
import AppToastContainer from './Components/ToastContainer';
import Events from './Pages/Event';

function App() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <AppToastContainer />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/donation" element={<Donation />} />
        <Route path="/project" element={<Project />} />
        <Route path="/project/project-detail/:id" element={<Foundation />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/impact" element={<Impact />} />
        <Route path="/donation-details/:id" element={<DonationDetail />} />
        <Route path="/payment-now" element={<PaymentNow />} />
        <Route path="/create-campaign" element={<CreateNewCampaign />} />
        <Route path="/campaign" element={<Campaign />} />
        <Route path="/members" element={<Members />} />
        <Route path="/my-profile" element={<Profile />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/feeds" element={<Feeds />} />
        <Route path="/event" element={<Events />} />
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms&condition" element={<TermsAndConditions />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
